import React from 'react';
import styles from './Loader.module.scss';
import Logo from 'assets/icons/logo.svg?react';
import PropTypes from 'prop-types';

function Loader({ size = 4, atStart, fullpage, section, extraClass }) {
  return (
    <section
      className={styles['spinner']}
      style={{
        height: fullpage ? '100%' : section ? '250px' : 'auto',
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        textAlign: atStart ? 'start' : 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <span className={styles.loader} aria-label='loading' style={{ height: `${size * 12}px`, width: `${size * 12}px`}} /> 
      <div className={`${styles.load} ${styles[extraClass]}`}>
        <Logo />
      </div>
    </section>
  );
}

Loader.propTypes = {
  size: PropTypes.number,
  atStart: PropTypes.bool,
  fullpage: PropTypes.bool,
  section: PropTypes.bool,
  extraClass: PropTypes.string
};
export default Loader;
